import {t} from "@lingui/core/macro";
import * as React from "react";
import * as SlateReact from "slate-react";

import {useMathEditorContext} from "@khan/guide-math-editor-context";
import {RequestInfo} from "@khan/shared-core";
import {ReferencesContext} from "@khan/slate-contexts";

import {AtIconButton} from "../icons/at-icon-button.tsx";

import {useShouldHideAddReferenceButton} from "./use-should-hide-add-reference-button.ts";

/**
 * A button that allows users to add references to their chat input by inserting an "@" symbol.
 * The button is hidden for students and teachers using student personas for security reasons.
 */
export const AddReferenceButton = () => {
    const editor = SlateReact.useSlate();
    const isMobile = RequestInfo.isMobile;
    const {isAnyActive: isAnyMathActive} = useMathEditorContext();
    const references = React.useContext(ReferencesContext);
    const shouldHideButton = useShouldHideAddReferenceButton();

    // Don't render the button for students or teachers using student personas
    if (shouldHideButton) {
        return null;
    }

    const onClickInitiateReference = () => {
        if (!isAnyMathActive) {
            if (!SlateReact.ReactEditor.isFocused(editor)) {
                SlateReact.ReactEditor.focus(editor);
            }
            editor.insertText("@");
        }
    };

    return (
        <AtIconButton
            onClick={onClickInitiateReference}
            disabled={references.disabled}
            title={t`Add reference`}
            isMobile={isMobile}
        />
    );
};
